import React from 'react'
import { TaskSeoNavSuper } from '../context/TaskSeoNav'
import { NavIn3 } from '../components/componentNav/NavIn'
import { DinCart } from '../components/componentHeader/Header'
import { Cart } from '../components/ComponentCartBy/Cart'

import { FooterAndButon } from '../components/componentFooter/Footer'

export function CartBy() {
  return (
    <>
      <TaskSeoNavSuper />
      <NavIn3/>
      <DinCart/>
      <Cart />
      <FooterAndButon/>
    </>
  )
}